module.exports = {

  ActionTypes: {
    SUBMIT_LOGIN: 'SUBMIT_LOGIN',
    SUBMIT_LOGIN_WITH_PASSCODE: 'SUBMIT_LOGIN_WITH_PASSCODE',
    SUBMIT_SAML_LOGIN: 'SUBMIT_SAML_LOGIN',
    VALIDATE_TOTP: 'VALIDATE_TOTP',
    VALIDATE_TOTP_WITH_SESSION: 'VALIDATE_TOTP_WITH_SESSION',
    VALIDATE_AUTHENTICATOR_WITH_SESSION: 'VALIDATE_AUTHENTICATOR_WITH_SESSION',
    VALIDATE_AUTHENTICATOR_WITH_INIT_ID: 'VALIDATE_AUTHENTICATOR_WITH_INIT_ID',
    VALIDATE_TOTP_FORGOT_PASSWORD: 'VALIDATE_TOTP_FORGOT_PASSWORD',
    RESEND_TOTP: 'RESEND_TOTP',
    GENERATE_AND_SEND_OTP_USING_TEMP_SECRET: 'GENERATE_AND_SEND_OTP_USING_TEMP_SECRET',
    SUBMIT_FORGOT_PASSWORD: 'SUBMIT_FORGOT_PASSWORD',
    SUBMIT_CHANGE_PASSWORD: 'SUBMIT_CHANGE_PASSWORD',
    SUBMIT_RESET_PASSWORD: 'SUBMIT_RESET_PASSWORD',
    SUBMIT_LINK_HD_ACCOUNT: 'SUBMIT_LINK_HD_ACCOUNT',
    SUBMIT_CONSENT_HD: 'SUBMIT_CONSENT_HD',
    GET_PASSWORDLESS_INFO: 'GET_PASSWORDLESS_INFO',
    GET_PASSWORDLESS_METHODS: 'GET_PASSWORDLESS_METHODS',
    SET_IS_INTRANET_REQUESTV2: 'SET_IS_INTRANET_REQUESTV2',
    VALIDATE_OTP_AUTH: 'VALIDATE_OTP_AUTH',
    GENERATE_OTP_CODE: 'GENERATE_OTP_CODE',
    GET_CDN_ASSETS: 'GET_CDN_ASSETS',
    GET_FOOTER_LOCALE: 'GET_FOOTER_LOCALE',
    GET_WEB_CONFIGURATIONS: 'GET_WEB_CONFIGURATIONS',
    GET_SUPPORTED_LOCALES: 'GET_SUPPORTED_LOCALES',
    DISPLAY_TOAST: 'DISPLAY_TOAST',
    GET_TRANSLATIONS: 'GET_TRANSLATIONS',
    GET_USER_LOGIN_STRATEGY: 'GET_USER_LOGIN_STRATEGY',
    GET_ALLOR_X_590_LOGIN: 'GET_ALLOR_X_590_LOGIN',
    GET_TWO_FA_TEMP_SECRET: 'GET_TWO_FA_TEMP_SECRET',
    VALIDATE_TOTP_APP_CODE: 'VALIDATE_TOTP_APP_CODE',
    VALIDATE_ADD_TOTP_APP_CODE: 'VALIDATE_ADD_TOTP_APP_CODE',
    CREATE_WEBAUTHN_CREDENTIALS: 'CREATE_WEBAUTHN_CREDENTIALS',
    CAPTURE_WEBAUTHN_CREDENTIALS: 'CAPTURE_WEBAUTHN_CREDENTIALS',
    SAVE_2FA_CRED: 'SAVE_2FA_CRED',
    GET_WEBAUTHN_CREDENTIALS: 'GET_WEBAUTHN_CREDENTIALS',
    GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN: 'GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN',
    GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN_1FA: 'GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN_1FA',
    DELETE_WEBAUTHN_CREDENTIALS: 'DELETE_WEBAUTHN_CREDENTIALS',
    GET_USER_DETAILS: 'GET_USER_DETAILS',
    GET_MFA_OPTIONS: 'GET_MFA_OPTIONS',
    GET_USER_MFA_METHODS: 'GET_USER_MFA_METHODS',
    CHANGE_USER_MFA_METHOD: 'CHANGE_USER_MFA_METHOD',
    DELETE_USER_MFA_METHOD: 'DELETE_USER_MFA_METHOD'

  },
  ApiResponse: {
    SUCCESS: 'Success',
    ERROR: 'Error'
  },
  LayoutConfig: {
    ROOT_ELEMENT_ID: 'ReactRootElement'
  },
  CdnContents: {
    BASE_URL: 'http://cdn.metro-group.com/idam/dev'
  },
  CookieDomains: {
    prod: {
      DE: 'metro.de',
      ES: 'makro.es',
      FR: 'metro.fr',
      HR: 'metro-cc.hr',
      RS: 'metro.rs',
      HU: 'metro.hu',
      MD: 'metro.md',
      NL: 'makro.nl',
      AT: 'metro.at',
      BG: 'metro.bg',
      CZ: 'makro.cz',
      IT: 'metro.it',
      KZ: 'metro-kz.com',
      PK: 'metro.pk',
      PL: 'makro.pl',
      PT: 'makro.pt',
      RO: 'metro.ro',
      SK: 'metro.sk',
      ES: 'makro.es',
      TR: 'metro-tr.com',
      UA: 'metro.ua'
    },
    dev: {
      DE: 'www-rev-sc.metro.de',
      ES: 'www-rev-sc.makro.es',
      FR: 'www-rev-sc.metro.fr',
      HR: 'www-rev-sc.metro-cc.hr',
      RS: 'www-rev-sc.metro.rs',
      HU: 'www-rev-sc.metro.hu',
      MD: 'www-rev-sc.metro.md',
      NL: 'www-rev-sc.makro.nl',
      AT: 'www-rev-sc.metro.at',
      BG: 'www-rev-sc.metro.bg',
      CZ: 'www-rev-sc.makro.cz',
      IT: 'www-rev-sc.metro.it',
      KZ: 'www-rev-sc.metro-kz.com',
      PK: 'www-rev-sc.metro.pk',
      PL: 'www-rev-sc.makro.pl',
      PT: 'www-rev-sc.makro.pt',
      RO: 'www-rev-sc.metro.ro',
      SK: 'www-rev-sc.metro.sk',
      ES: 'www-rev-sc.makro.es',
      TR: 'www-rev-sc.metro-tr.com',
      UA: 'www-rev-sc.metro.ua'
    }
  },
  UserTypes: {
    EMP: 'EMP',
    CUST: 'CUST',
    FUNC: 'FUNC',
    SUPP: 'SUPP',
    DEV: 'DEV'
  },
  Issuer: {
    METRO_LINK_PLUS: 'METROLinkPlus',
    M_IDENTITY: 'M|Identity'
  },
  Providers: {
    KEYCLOAK: "keycloak"
  },
  SOCIAL_LOGIN: {
    DISH_CONSTANTS: {
      clientsToOmit: ["MMARKET_DE", "MMARKET_ES", "MMARKET_IT"],
      clientId: "DISH_APP",
      realmId: "HD_REALM_SSO",
      redirectUrl: {
        local: "https://dev.sso.app.hd.digital/auth/realms/HDCustomers-nonprod/broker/oidc/endpoint",
        dev: "https://dev.sso.app.hd.digital/auth/realms/HDCustomers-nonprod/broker/oidc/endpoint",
        pp: "https://dev.sso.app.hd.digital/auth/realms/HDCustomers-nonprod/broker/oidc/endpoint",
        prod: "https://sso.dish.co/auth/realms/HD-SSO/broker/oidc/endpoint"
      },
      scope: "openid",
      state: "statelessness",
      privacyPolicyLink: "https://www.dish.co/DE/en/privacy-policy/",
      termsAndConditionsLink: "https://www.dish.co/DE/en/terms-of-use/"
    },
    EVENTS: {
      CLICK: "click",
      HOVER: "hover"
    },
    PROVIDER: {
      FACEBOOK: "facebook",
      DISH: "dish",
      GOOGLE: "google"
    }
  },
  Links: {
    AUTHORIZE_API: '/web/authz/authorize',
    AUTHORIZE_URL: "/authorize/api/oauth2/authorize",
    PROCESS_SAML_URL: "/saml/process_saml",
    SIGN_IN_PAGE: "/web/Signin",
    SAML_SIGN_IN_PAGE: "/web/saml/Signin",
    RESET_PASSWORD_PAGE: "/web/reset-password-page/",
    END_SESSION_CALLBACK: "/authorize/api/oauth2/op_session_end_callback",
    SAML_END_SESSION_CALLBACK: "/saml/saml_session_end_callback",
    ERROR_PAGE: "/web/Error",
    LOGIN_PREFERENCES: "/web/setloginpreferences",
    FORGOTPASSWORD_URL: "/web/forgot-password?",
    VALIDATEOTP_URL: "/web/validate-otp?",
    SOCIAL_LOGIN_REDIRECT_URL: "/authorize/api/social_login",
    LINK_ACCOUNT: "/web/authc/account/link",
    HOW_IT_WORKS: "https://de.metrolink-plus.com/howItWorksHelpText",
    CONSENT: "/web/authc/account/consent"
  },
  Templates: {
    FOOTER_DATA: 'footerdata',
    CUST_COMPONENT_URL: 'customlocalemessage',
    WEBPAGE_CONFIGURATIONS: 'webpageconfigurations'
  },
  FooterPlaceHolders: {
    COUNTRY_CODE: '{countryCode}'
  },
  UrlParams: {
    CLIENT_ID: "client_id",
    REDIRECT_URI: "redirect_uri",
    USER_TYPE: "user_type",
    RESPONSE_TYPE: "response_type",
    RESPONSE_MODE: "response_mode",
    COUNTRY_CODE: "country_code",
    ACCOUNT_ID: "account_id",
    LOCALE_ID: "locale_id",
    REALM_ID: "realm_id",
    ENCRYPTED_CODE: "encrypted_code",
    STATE: "state",
    SCOPE: "scope",
    CODE_CHALLENGE: "code_challenge",
    CODE_CHALLENGE_METHOD: "code_challenge_method",
    CONSENT: "consent",
    CONSENT_CODE: "consent_code",
    PROMPT: "prompt",
    NONCE: "nonce",
    LOGIN_ID: "login_id",
    PASSWORDLESS: "passwordless",
    OTP_CHANNEL : "otpChannel",
    SESSION_STATE: "session_state",
    TRACE_ID: "DR-Trace-ID",
    INIT_SESSION_ID: "init_session_id",
    LOGIN_METHOD: "login_method",
    USER_ID: "user_id",
    AUTHENTICATION_CERTIFICATE: "authenticationcertificate",
    SAML_AUTHENTICATION_CERTIFICATE: "authentication_certificate",
    CLIENTS_TO_BE_LOGOUT: "logout_clientids",
    PREVIEW: "preview",
    ID_TOKEN: "id_token",
    EMAIL: "email",
    MOBILE: "mobile",
    PROVIDER: "provider",
    SLP_FINAL_REDIRECT_URI: "slp_final_redirect_uri",
    SLP_FINAL_CLIENT_ID: "slp_final_client_id",
    SLP_FINAL_REALM_ID: "slp_final_realm_id"
  },
  EmailSentCode: {
    FORGOTPASSWORD: 200,
    RESETPASSWORD: 300,
    RESETPASSWORDERROR: 400,
    VALIDATETOTPERROR: 410
  },
  LocalAssetsPath: {
    FORGOT_PASSWORD_EMAIL_SENT_IMG_PATH: "/web/assets/images/Email_Sent.png",
    SUCCESS_RESET_PASSWORD_EMAIL_SENT_IMG_PATH: "/web/assets/images/SuccessEmail.png"
  },
  CdnAssetsPath: {
    HEADER_LOGO_IMG_REL_PATH: "/images/header_logo_img.png",
    HEADER_CUST_LOGO_IMG_REL_PATH: "/images/header_cust_logo_img.png",
    HEADER_LOGO_IMG: "/header_logo_img.png",
    HEADER_CUST_LOGO_IMG: "/header_cust_logo_img.png",
    BRANDING_LOGOS_PATH: "/Branding/Logos/",
    BRANDING_FAVICONS_PATH: "/Branding/Favicons/",
    FAVICON_IMG_REL_PATH: "/images/favicon.png",
    FAVICON_IMG: "/favicon.png",
    FAVICON_IMG_ASSET_URL: "/web/assets/images/favicon.ico"
  },
  passwordValidationCriterias: {
    AT_LEAST_EIGHT_CHAR: 8,
    MAX_FIFTY_CHAR: 50,
    SPACE: ''
  },
  cookie: {
    METRO_IDENTITY: 'metroIdentity'
  },
  headerLogoRedirectUrls: {
    DE: 'https://www.metro.de/',
    FR: 'http://shop.metro.fr/',
    HU: 'https://www.metro.hu/',
    ES: 'https://www.makro.es/',
    PT: 'https://www.makro.pt/',
    RU: 'https://www.metro-cc.ru',
    RO: 'https://www.metro.ro',
    NL: 'https://www.makro.nl',
    BG: 'https://www.metro.bg/',
    MD: 'https://www.metro.md'
  },
  countryDefaultLocaleId: {
    AT: 'de-DE',
    BE: 'fr-BE',
    BG: 'bg-BG',
    CH: 'de-DE',
    CN: 'zh-CN',
    CZ: 'cs-CZ',
    DE: 'de-DE',
    ES: 'es-ES',
    FR: 'fr-FR',
    HR: 'hr-HR',
    HU: 'hu-HU',
    IS: 'is-IS',
    IT: 'it-IT',
    IN: 'en-IN',
    JP: 'ja-JP',
    KZ: 'ru-KZ',
    MD: 'ro-MD',
    NL: 'nl-NL',
    PK: 'ur-PK',
    PL: 'pl-PL',
    PT: 'pt-PT',
    RO: 'ro-RO',
    RS: 'sr-RS',
    RU: 'ru-RU',
    SK: 'sk-SK',
    TR: 'tr-TR',
    UA: 'uk-UA',
  },
  LOCALE_EN_GB: 'en-GB',
  GENERIC_ERROR_CODE: "0202001",
  ONE_FA_WEB_AUTHN: "1faByWebAuthnText",
  TWO_FA_TOTP: "2FA_TOTP",
  TWO_FA_OTP: "2FA_OTP",
  TWO_FA_TOTP_APP: "2FA_TOTP_APP",
  TWO_FA_WEB_AUTHN: "2FA_WEB_AUTHN",
  TWO_FA_FOR_FORGOTPASSWORD: "2FA_FORGOT_PASSWORD",
  TOTP_VIEW_OPTIONS: {
    "2FA_TOTP": {
      headerMessageKey: 'totp_header',
      resendTotpAllowed: true
    },
    "2FA_OTP": {
      headerMessageKey: 'validateOtpTextPhone',
      resendTotpAllowed: false,
      displayTotpSentMessage: true
    },
    "2FA_TOTP_APP": {
      headerMessageKey: '2faByAppHeaderText',
      resendTotpAllowed: false
    },
    "2FA_WEB_AUTHN": {
      headerMessageKey: '2faByWebAuthnText',
      resendTotpAllowed: false
    },
    "2FA_FORGOT_PASSWORD": {
      headerMessageKey: 'totp_header_forgot_password',
      resendTotpAllowed: false,
      displayTotpSentMessage: true

    }
  },
  USER_AUTHMETHODS: {
    "2FA_TOTP_APP": {
      headerMessageKey: 'loginpreferences.2famethods.codes_via_app'
    },
    "2FA_TOTP": {
      headerMessageKey: 'loginpreferences.2famethods.codes_via_sms'
    },
    "2FA_WEB_AUTHN": {
      headerMessageKey: 'loginpreferences.2famethods.webauthn.security_device'
    }
  },
  DEFAULT_COUNTRY_CODE: "default",
  DEFAULT_LOCALE_ID: "default",
  LOGIN_SEPERATOR: " | ",
  Encrypt: {
    key: '&F)J@NcRfUjWnZr4',
    ivKey: 'aPdSgVkYp3s6v9y$'
  },
  GAFields: {
    event: 'event',
    category: 'category',
    solution: 'GA360_solution',
    salesLine: 'GA360_salesLine',
    country: 'GA360_country',
    pageName: 'GA360_pageName',
    pageTitle: 'GA360_pageTitle',
    languageSelected: 'GA360_languageSelected',
    templateType: 'GA360_templateType',
    breadcrumb: 'GA360_breadcrumb',
    userInterface: 'GA360_userInterface',
    errorPage: 'GA360_errorPage',
    statusCode: 'GA360_statusCode',
    userType: 'GA360_userType',
    storeId: 'GA360_storeId',
    storeName: 'GA360_storeName',
    loggedIn: 'GA360_loggedIn',
    cutomerTier:'GA360_customerTier',
    type: 'type',
    label: 'label'
  },
  GAFieldsValues: {
    solution: 'IDAM',
    salesLine_makro: 'makro',
    salesLine_metro: 'metro',
    makroCountries: ['PT', 'NL', 'PL', 'ES', 'CZ'],
    supportedCountries: ['BE', 'BG', 'CN', 'DE', 'FR', 'FR', 'IN', 'IT', 'JP', 'KZ', 'HR', 'MM', 'MD', 'NL', 'AT', 'PK', 'PL', 'PT', 'RO', 'RU', 'RS', 'SK', 'ES', 'CZ', 'TR', 'UA', 'HU'],
    supportedUserTypes: ['EMP', 'CUST', 'SUPP', 'FUNC', 'DEV'],
    notloggedin: 'not-logged-in',
    loggedin: 'logged-in',
    nostoreselected: 'no-store-selected',
    unknown: 'unknown',
    noerror: 'no-error',
    errorpage: 'errorpage',
    responsivesite: 'responsive-site',
    none: 'none',
    nobreadcrumb: 'no-breadcrumb',
    anonymous: 'anonymous',
    nocountry: 'no-solutionCountry',
    pageViewType: {
      login: 'Login',
      linkAccount: 'LinkAccount',
      consent: 'Consent',
      forgotPassword: 'ForgotPassword',
      resetPassword: 'ResetPassword',
      changePassword: 'ChangePassword',
      signOut: 'SignOut',
      setLoginpreferences: 'SetLoginPreferences',
      updateLoginpreferences: 'UpdateLoginPreferences',
      error: 'Error'
    },
    LoginCUST: {
      pageTitle: 'customerlogin',
      templateType: 'login',
      userType: 'customer'
    },
    LoginEMP: {
      pageTitle: 'employeelogin',
      templateType: 'login',
      userType: 'employee'
    },
    LoginSUPP: {
      pageTitle: 'supplierlogin',
      templateType: 'login',
      userType: 'supplier'
    },
    LoginFUNC: {
      pageTitle: 'functionaluserlogin',
      templateType: 'login',
      userType: 'anonymous'
    },
    Login: {
      pageTitle: 'login',
      templateType: 'login',
      userType: 'anonymous'
    },
    ForgotPasswordCUST: {
      pageTitle: 'customerforgotpassword',
      templateType: 'forgotpassword',
      userType: 'customer'
    },
    ForgotPasswordEMP: {
      pageTitle: 'employeeforgotpassword',
      templateType: 'forgotpassword',
      userType: 'employee'
    },
    ForgotPasswordSUPP: {
      pageTitle: 'supplierforgotpassword',
      templateType: 'forgotpassword',
      userType: 'supplier'
    },
    ForgotPasswordFUNC: {
      pageTitle: 'functionaluserforgotpassword',
      templateType: 'login',
      userType: 'anonymous'
    },
    ForgotPassword: {
      pageTitle: 'forgotpassword',
      templateType: 'forgotpassword',
      userType: 'anonymous'
    },
    SetLoginPreferencesCUST: {
      pageTitle: 'customerSetLoginPreferences',
      templateType: 'SetLoginPreferences',
      userType: 'customer'
    },
    SetLoginPreferencesEMP: {
      pageTitle: 'employeeSetLoginPreferences',
      templateType: 'SetLoginPreferences',
      userType: 'employee'
    },
    SetLoginPreferencesSUPP: {
      pageTitle: 'supplierSetLoginPreferences',
      templateType: 'SetLoginPreferences',
      userType: 'supplier'
    },
    SetLoginPreferencesFUNC: {
      pageTitle: 'functionaluserSetLoginPreferences',
      templateType: 'SetLoginPreferences',
      userType: 'anonymous'
    },
    SetLoginPreferences: {
      pageTitle: 'SetLoginPreferences',
      templateType: 'SetLoginPreferences',
      userType: 'anonymous'
    },
    UpdateLoginPreferencesCUST: {
      pageTitle: 'customerUpdateLoginPreferences',
      templateType: 'UpdateLoginPreferences',
      userType: 'customer'
    },
    UpdateLoginPreferencesEMP: {
      pageTitle: 'employeeUpdateLoginPreferences',
      templateType: 'UpdateLoginPreferences',
      userType: 'employee'
    },
    UpdateLoginPreferencesSUPP: {
      pageTitle: 'supplierUpdateLoginPreferences',
      templateType: 'UpdateLoginPreferences',
      userType: 'supplier'
    },
    UpdateLoginPreferencesFUNC: {
      pageTitle: 'functionaluserUpdateLoginPreferences',
      templateType: 'UpdateLoginPreferences',
      userType: 'anonymous'
    },
    UpdateLoginPreferences: {
      pageTitle: 'UpdateLoginPreferences',
      templateType: 'UpdateLoginPreferences',
      userType: 'anonymous'
    },
    ChangePasswordCUST: {
      pageTitle: 'customerchangepassword',
      templateType: 'changepassword',
      userType: 'customer'
    },
    ChangePasswordEMP: {
      pageTitle: 'employeechangepassword',
      templateType: 'changepassword',
      userType: 'employee'
    },
    ChangePasswordSUPP: {
      pageTitle: 'supplierchangepassword',
      templateType: 'changepassword',
      userType: 'supplier'
    },
    ChangePasswordFUNC: {
      pageTitle: 'functionaluserchangepassword',
      templateType: 'changepassword',
      userType: 'anonymous'
    },
    ChangePassword: {
      pageTitle: 'changepassword',
      templateType: 'changepassword',
      userType: 'anonymous'
    },
    ResetPasswordCUST: {
      pageTitle: 'customerresetpassword',
      templateType: 'resetpassword',
      userType: 'customer'
    },
    ResetPasswordEMP: {
      pageTitle: 'employeeresetpassword',
      templateType: 'resetpassword',
      userType: 'employee'
    },
    ResetPasswordSUPP: {
      pageTitle: 'supplierresetpassword',
      templateType: 'resetpassword',
      userType: 'supplier'
    },
    ResetPasswordFUNC: {
      pageTitle: 'functionaluserresetpassword',
      templateType: 'resetpassword',
      userType: 'anonymous'
    },
    ResetPassword: {
      pageTitle: 'resetpassword',
      templateType: 'resetpassword',
      userType: 'anonymous'
    },
    SignOutCUST: {
      pageTitle: 'customersignout',
      templateType: 'signout',
      userType: 'customer'
    },
    SignOutEMP: {
      pageTitle: 'employeesignout',
      templateType: 'signout',
      userType: 'employee'
    },
    SignOutSUPP: {
      pageTitle: 'suppliersignout',
      templateType: 'signout',
      userType: 'supplier'
    },
    SignOutFUNC: {
      pageTitle: 'functionalusersignout',
      templateType: 'signout',
      userType: 'anonymous'
    },
    SignOut: {
      pageTitle: 'signout',
      templateType: 'signout',
      userType: 'anonymous'
    },
    ErrorCUST: {
      pageTitle: 'customerloginerror',
      templateType: 'login',
      userType: 'customer'
    },
    ErrorEMP: {
      pageTitle: 'employeeloginerror',
      templateType: 'error',
      userType: 'employee'
    },
    ErrorSUPP: {
      pageTitle: 'supplierloginerror',
      templateType: 'error',
      userType: 'supplier'
    },
    ErrorFUNC: {
      pageTitle: 'functionaluserloginerror',
      templateType: 'error',
      userType: 'functional'
    },
    Error: {
      pageTitle: 'error',
      templateType: 'error',
      userType: 'anonymous'
    },
    hostnameCountryCodeMap: {
      'idam.metro.be': 'BE',
      'idam.metro.bg': 'BG',
      'idam.metro.cn': 'CN',
      'idam.metro.de': 'DE',
      'idam.makro.es': 'ES',
      'idam.metro.fr': 'FR',
      'idam.metro-cc.hr': 'HR',
      'idam.metro.hu': 'HU',
      'idam.metro.it': 'IT',
      'idam.metro-cc.jp': 'JP',
      'idam.metro.com.kz': 'KZ',
      'idam.metro.md': 'MD',
      'idam.makro.nl': 'NL',
      'idam.metro.pk': 'PK',
      'idam.makro.pt': 'PT',
      'idam.metro.ro': 'RO',
      'idam.metro.rs': 'RS',
      'idam.metro-cc.ru': 'RU',
      'idam.metro-tr.com': 'TR',
      'idam.metro.ua': 'UA'
    }
  },
  ReCaptcha: {
    siteKey: '6Lcivj4bAAAAAEgP2z-xDDoCdvrics2uFL9WxpRn'
  },
  StatusComponents: {
    '400': 'MissingParameter400',
    '403': 'Forbidden403',
  },
  ERROR_CODES: {
    HTTP_STATUS_BAD_REQUEST: 400,
    HTTP_STATUS_INTERNAL_ERROR: 500
  },
  LoginPreferences: {
    ID_TOKEN: 'id_token',
    REDIRECT_URI: 'redirect_uri',
    LOGIN_PREFERENCES_PATHNAME: '/web/loginpreferences',
    AUTH_METHOD_MISMATCH_ERROR_DESC: 'Invalid User authentication_method',
    AUTH_METHOD_USER_CREDENTIAL: 'USER_CREDENTIALS',
    UNKNOWN_AUTH_TOKEN_STATUS: 403,
    TWO_FA_TOTP_SMS_OPTION_MAP: "codes_via_sms",
    TWO_FA_TOTP_APP_OPTION_MAP: "codes_via_app",
    TWO_FA_WEB_AUTHN_OPTION_MAP: "webauthn",
    // User will be navigated back to login preferences home screen for the following error codes
    ERROR_CODES_WHERE_USER_REDIRECTS: ['0203006', '0203005', '0999999', '0203205', '0203002', '0203003', '0201020']
  },
  Metro_Logo_Variant_Mapping: {
    'metro': 'metro.png',
    'makro': 'makro.png',
    'makro-nl': 'makro-nl.png',
    'metro-china': 'metro-china.png',
    'metro-china-inverted': 'metro-china-inverted.png',
    'metro-turkey': 'metro-turkey.png',
    'metro-turkey-inverted': 'metro-turkey-inverted.png',
    'metro-united': 'metro-united.png',
    'metro-united-inverted': 'metro-united-inverted.png',
    'metro-link-plus': "metro-link-plus.png",
    'metro-logistics': "metro-logistics.png",
    'real': "real.png",
  },
  Deviant_Logos: {
    logos: ['metro-link-plus', 'metro-china-inverted']
  },
  COUNTRY_CODE_FOR_NUMBERS: {
    AT: new countryCodeForNumbers('+43', 'AT', 'Austria'),
    BE: new countryCodeForNumbers('+32', 'BE', 'Belgium'),
    BG: new countryCodeForNumbers('+359', 'BG', 'Bulgaria', '+999'),
    CN: new countryCodeForNumbers('+86', 'CN', 'China'),
    CZ: new countryCodeForNumbers('+420', 'CZ', 'Czech Republic', '+999'),
    DE: new countryCodeForNumbers('+49', 'DE', 'Germany'),
    ES: new countryCodeForNumbers('+34', 'ES', 'Spain'),
    FR: new countryCodeForNumbers('+33', 'FR', 'France'),
    HR: new countryCodeForNumbers('+385', 'HR', 'Croatia', '+999'),
    HU: new countryCodeForNumbers('+36', 'HU', 'Hungary'),
    IN: new countryCodeForNumbers('+91', 'IN', 'India'),
    IS: new countryCodeForNumbers('+354', 'IS', 'Iceland'),
    IT: new countryCodeForNumbers('+39', 'IT', 'Italy'),
    JP: new countryCodeForNumbers('+81', 'JP', 'Japan'),
    KZ: new countryCodeForNumbers('+7', 'KZ', 'Kazakhstan', '+9'),
    MD: new countryCodeForNumbers('+373', 'MD', 'Moldova', '+999'),
    NL: new countryCodeForNumbers('+31', 'NL', 'Netherlands'),
    PK: new countryCodeForNumbers('+92', 'PK', 'Pakistan'),
    PL: new countryCodeForNumbers('+48', 'PL', 'Poland'),
    PT: new countryCodeForNumbers('+351', 'PT', 'Portugal', '+999'),
    RO: new countryCodeForNumbers('+40', 'RO', 'Romania'),
    RS: new countryCodeForNumbers('+381', 'RS', 'Serbia', '+999'),
    RU: new countryCodeForNumbers('+7', 'RU', 'Russia', '+9'),
    SK: new countryCodeForNumbers('+421', 'SK', 'Slovakia', '+999'),
    TR: new countryCodeForNumbers('+90', 'TR', 'Turkey'),
    UA: new countryCodeForNumbers('+380', 'UA', 'Ukraine', '+999'),
    default: new countryCodeForNumbers('+99', 'default', 'Default', '+99'),
  },
  CHANGE_LOGIN_PREFERNCES: {
    IDENTITY_WORKFLOW_URLS: {
      local: "https://dev.identity.metro.info/login-preferences",
      dev: "https://dev.identity.metro.info/login-preferences",
      pp: "https://pp.identity.metro.info/login-preferences",
      prod: "https://identity.metro.info/login-preferences"
    }
  },
  INTRANET_REQUEST: "intranet",
  INTERNET_REQUEST: "internet",
  EXTERNAL_REQUEST: "external",
  DEFAULT_PHONE_NUMBER_LANGUAGE: "DE"
};

function countryCodeForNumbers(countryCodePhoneNumber, countryCode, countryName, maskedCountryCodePhoneNumber = '+99', maskedCountryPhoneNumber = '9999999999999') {
  this.countryCodePhoneNumber = countryCodePhoneNumber;
  this.countryCode = countryCode;
  this.countryName = countryName;
  this.maskedCountryCodePhoneNumber = maskedCountryCodePhoneNumber;
  this.maskedCountryPhoneNumber = maskedCountryPhoneNumber;
}
